function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M14.827 1.364A11.97 11.97 0 0012 1v2a9.73 9.73 0 012.192.269l.635-1.905zM16.086 3.912c.56.255 1.114.571 1.636.96l1.45-1.45a11.012 11.012 0 00-2.448-1.425l-.638 1.915zM1 21h2v-2.67C4.99 21.15 8.28 23 12 23a10.995 10.995 0 0010.898-9.492h-2.024C20.157 17.76 16.456 21 12 21c-3.12 0-5.87-1.59-7.48-4H7v-2H1v6zM22.967 11c.011.167.02.336.025.508H20.99a10.283 10.283 0 00-.24-1.9l1.902-.714c.157.65.265 1.352.315 2.106zM22.006 7a9.405 9.405 0 00-1.388-2.196l-1.45 1.45c.35.433.663.92.928 1.462L22.006 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.15 9.2c0 .94.86 1.31 2.64 1.9 2.4.83 3.01 2.05 3.01 3.44 0 2.576-2.398 3.108-2.873 3.214l-.027.006V19h-2v-1.29c-.62-.18-2.27-.77-2.9-2.96l1.66-.67c.06.22.58 2.09 2.4 2.09.93 0 1.98-.48 1.98-1.61 0-.96-.7-1.47-2.28-2.03-.07-.026-.146-.053-.226-.08-1.154-.41-3.124-1.106-3.124-3.23 0-.1.01-2.4 2.49-2.96V5h2v1.24c1.72.32 2.39 1.79 2.54 2.24l-1.58.67c-.11-.35-.59-1.34-1.9-1.34-.7 0-1.81.37-1.81 1.39z"
  }));
};
const SvgRefund = styled(BaseComponent).withConfig({
  displayName: "Refund__SvgRefund",
  componentId: "sc-7t7vgp-0"
})(["outline:none;"]);
SvgRefund.isIcon = true;
SvgRefund.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgRefund;